module.exports = __webpack_public_path__ + "img/x-Uu.dbdb4a28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/x-Uu.jpg
// module id = yoP3
// module chunks = 1